// Vendor imports
const _ = require('lodash')
const qs = require('qs')
// Shared imports
const BemEntity = require('shared/bem')
// Client V1 imports
const businessEvents = require('client/lib/business-events')
const WindowLib = require('client/lib/window')
const Modal = require('client/components/modal')
// Template imports
const userShareModalTemplate = require('*views/modals/user-share')

const bem = BemEntity('user-share-modal')

const HREF_SELECTOR = bem.elementSelector('href')
const COPY_BUTTON_SELECTOR = bem.elementSelector('copy-button')

function shareUserHref(user, socialMedium) {
    // const {protocol, hostname, port} = window.location
  // Hard-code production URL scheme; cannot share `localhost` links
  const [protocol, hostname, port] = ['https:', 'mix.com', '']
  return protocol + '//' + hostname + (port ? ':' + port : '') +
    '/' + user.username +
    '?' + qs.stringify({
      'utm_source': socialMedium,
      'utm_medium': 'web',
      'utm_campaign': 'user_profile',
      'utm_term': 'button'
    })
}

function socialShareUserHref(user, socialMedium) {
  const href = shareUserHref(user, socialMedium)
  switch (socialMedium) {
    case 'facebook': {
      return '//facebook.com/sharer.php' +
        '?u=' + encodeURIComponent(href)
    }
    case 'twitter': {
      const text = user['display_name'] + ' is on Mix at ' + href + ' @getmixapp'
      return '//twitter.com/intent/tweet?lang=en' +
        '&text=' + encodeURIComponent(text)
    }
    case 'pinterest': {
      const media = user['photo_url']
      return '//pinterest.com/pin/create/button/' +
        '?url=' + encodeURIComponent(href) +
        '&media=' + encodeURIComponent(media)
    }
    case 'email': {
      const subject = 'Check out this cool person on Mix'
      const body =
        'Heyo, \r\n\r\n' +
        user['display_name'] + ' is on Mix at ' + href
      return 'mailto:?subject=' + subject +
        '&body=' + encodeURIComponent(body)
    }
    case 'copy':
      return href
  }
}

const shareWindowSizes = {
  'facebook': [555, 625],
  'twitter': [600, 300],
  'pinterest': [750, 750]
}

module.exports = class UserShareModal extends Modal {
  constructor(options) {
    // Handle options
    if (!_.get(options, 'shareUser')) {
      throw Error('Required option `shareUser` is not an Object with `hash` property')
    }
    super(_.defaults(options, {
      modalTemplate: userShareModalTemplate,
      modalClassName: 'user-share-modal',
      modalTitle: 'Share'
    }))
  }

  willRender(templateOptions) {
    const { shareUser } = templateOptions
    const shareHrefs = templateOptions.shareHrefs = {}
    _.each(['copy', 'facebook', 'twitter', 'pinterest', 'email'], socialMedium => {
      shareHrefs[socialMedium] = socialShareUserHref(shareUser, socialMedium)
    })
  }

  didRender() {
    // Inherit dismissal listeners
    super.didRender()
    // Add social button listeners
    this.$el.on('click', HREF_SELECTOR, this.openShareWindow.bind(this))
    this.$el.on('click', COPY_BUTTON_SELECTOR, this.copyShareUrl.bind(this))
  }

  copyShareUrl(event) {
    event.preventDefault()
    const button = event.currentTarget
    const input = button.form.copy
    input.select()
    document.execCommand('copy')
    button.textContent = 'Copied!'
    this.trackShare('copy')
  }

  openShareWindow(event) {
    const $target = $(event.currentTarget)
    const shareType = $target.attr('data-share-type')
    this.trackShare(shareType)
    if (shareType === 'email') {
      return // Let the browser handle mailto: links
    }
    event.preventDefault()
    const [width, height] = shareWindowSizes[shareType]
    WindowLib.openWindow(
      $target.attr('href'),
      `share-${shareType}`,
      WindowLib.centeredWindowFeatures(width, height)
    )
  }

  trackShare(shareType) {
    const { shareUser } = this.options
    businessEvents.trackInternal('share-external', {
      'actioned_object_type': 'user',
      'actioned_object_id': shareUser.id,
      'extra_properties': shareType
    })
    businessEvents.trackSegment('share-external', {
      type: shareType,
      'user_id': shareUser.id
    })
  }

}
